import KioskCreationDefinitionCustomer from './KioskCreationDefinitionCustomer'
export default KioskCreationDefinitionCustomer
